<template>
  <div class="picker">
    <div class="picker__container content-container">

      <div class="picker__close" data-aos="fade" data-aos-delay="100">
        <ButtonRound :data="closeButton" @onClick="onClose"/>
      </div>

      <h2 class="picker__title h5" v-if="title" data-aos="fade" data-aos-delay="125">
        {{ title }}
      </h2>

      <h3 class="picker__description" v-if="description" data-aos="fade" data-aos-delay="150">
        {{ description }}
      </h3>

      <div class="picker__items">
        <div class="picker__item" v-for="(item, idx) in items" :key="idx">
          <button type="button" class="picker__button" @click="onToggleActive(item.id)"
                  data-aos="fade"
                  data-aos-delay="100">
            <span class="picker__check" v-if="item.id === id">
              <Icon name="16/check"/>
            </span>

            <span class="picker__image" v-if="item.image">
              <Image :data="item.image"/>
            </span>

            <span class="picker__name" v-if="item.name">
              {{ item.name }}
            </span>
          </button>
        </div>
      </div>

      <div class="picker__action" v-if="action">
        <div data-aos="fade" data-aos-delay="150">
          <AppButton :data="action" @onClick="onSave"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image from '@/components/Image/Image.vue';
import AppButton from '@/components/AppButton/AppButton.vue';
import Icon from '@/components/Icon/Icon.vue';
import ButtonRound from '@/components/ButtonRound/ButtonRound.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Picker',
  components: {
    ButtonRound, Icon, AppButton, Image,
  },
  data() {
    return {
      title: this.$store.getters['app/getStaticValue']('BACKGROUNDS_LIST_TITLE'),
      description: this.$store.getters['app/getStaticValue']('BACKGROUNDS_LIST_DESCRIPTION'),
      id: null,

      closeButton: {
        icon: '24/cross',
      },
    };
  },
  computed: {
    ...mapGetters({
      data: 'app/getBackgroundListData',
      currentVideo: 'app/getCurrentVideo',
    }),

    items() {
      return this.data?.items || [];
    },
    canSave() {
      if (!this.data) return null;

      const newSrc = (this.data?.items || []).find((item) => item.id === this.id)?.video?.src;
      const currentSrc = this.currentVideo?.src;

      return newSrc !== currentSrc;
    },
    action() {
      return {
        title: this.$store.getters['app/getStaticValue']('BACKGROUNDS_BUTTON_TITLE'),
        text: this.$store.getters['app/getStaticValue']('BACKGROUNDS_BUTTON_TITLE'),
        disabled: !this.canSave,
      };
    },
  },
  methods: {
    ...mapMutations({
      toggleActive: 'app/backgroundListToggleActive',
    }),

    onToggleActive(id) {
      this.id = id;
    },
    onClose() {
      this.$emit('onClose');
    },
    onSave() {
      if (!this.canSave) return;

      this.toggleActive(this.id);
      this.onClose();
      this.$emit('onReload');
    },
  },
  mounted() {
    this.id = (this.data?.items || []).find((item) => item.active)?.id || null;
  },
};
</script>

<style lang="scss" scoped>
@import "Picker";
</style>
